import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import logger from "../../../../../utils/logger";
import { sendFeedback } from "../../../../controller/reducer/ui";
import StarUI from "./stars";
import "./styles.css";

const FeedBackMoodal = ({ show, onClose }) => {
  const [rating, setRating] = useState("5");
  const [msg, setMsg] = useState("");
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  const submitTask = (e) => {
    e.preventDefault();
    const data = {
      msg,
      email,
      rating: parseInt(rating),
    };
    logger()(data);
    dispatch(sendFeedback(data));
    onClose();
  };

  return (
    <Modal show={show} animation={false} onHide={onClose}>
      <Modal.Header className="bg-dark">
        <Modal.Title className="text-light">Feedback</Modal.Title>
      </Modal.Header>
      <Form onSubmit={submitTask}>
        <Modal.Body>
          Rating:
          <StarUI rating={rating} setRating={setRating} />
          <Form.Group controlId="msg">
            <Form.Label>Enter Message*</Form.Label>
            <Form.Control
              maxLength="200"
              required
              as="textarea"
              rows={2}
              placeholder="Message"
              value={msg}
              onChange={(e) => setMsg(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Make it as descriptive as possible
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Enter Email</Form.Label>
            <Form.Control
              maxLength="50"
              type="email"
              placeholder="Email Here"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Enter is for us to reach out to you
            </Form.Text>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="bg-light">
          <Button variant="primary" type="submit">
            Send Feedback
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FeedBackMoodal;
